import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagArs = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_148_6782)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.0002 -0.000930786C7.24267 -0.000930786 3.13192 2.76774 1.19092 6.78169H22.8094C20.8685 2.76774 16.7577 -0.000930786 12.0002 -0.000930786Z",
				fill: "#338AF3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.0004 23.9988C16.7579 23.9988 20.8687 21.2301 22.8097 17.2161H1.19116C3.13216 21.2301 7.24291 23.9988 12.0004 23.9988Z",
				fill: "#338AF3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.5866 12.0001L14.1211 12.6894L14.9015 14.1088L13.3101 13.8043L13.1084 15.4119L12 14.2296L10.8915 15.4119L10.6899 13.8043L9.09846 14.1087L9.87883 12.6894L8.41333 12.0001L9.87888 11.3107L9.09846 9.89138L10.6898 10.1958L10.8915 8.58817L12 9.77054L13.1085 8.58817L13.3101 10.1958L14.9015 9.89138L14.1211 11.3107L15.5866 12.0001Z",
				fill: "#FFDA44"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_148_6782",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgFlagArs;
